export const convertToOptions = object => Object.keys(object).map(key => ({value: key, label: object[key]}));
export const convertKeysToOptions = obj => Object.keys(obj).map(key => ({value: key, label: key}));
export const convertToValue = (value, data) => data[value] || '';
